/* eslint-disable react/jsx-key */
// Components==============
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React, { Fragment, useState } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { groupSparksBySkill } from 'utilities/groupSparksBySkill';
import Spark from '../Spark/Spark';
import './SparkGoals.module.scss';
import SparkItem from './component/SparkItem';
// =========================

type Props = {
  sparks?: SparkEntity[];
  handleDelete?: (sparkItem: SparkEntity) => void;
  type?: 'reflection';
  setSparkLinkModalIsOpen?: (isOpen: boolean) => void;
  getSparkName?: (id: number) => void;
};

export default function SparkGoals({
  sparks,
  handleDelete,
  type,
  setSparkLinkModalIsOpen,
  getSparkName,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const skillObj = useRedux((state) => state.skill?.entities.byId);
  const groupedSparks = groupSparksBySkill(sparks, skillObj);

  const goalCount = sparks?.filter((spark) => !spark.notInGoals).length;
  const doneCount = sparks?.filter((spark) => spark.done).length;
  const doneAndNotInGoalsCount = sparks?.filter(
    (spark) => spark.done && spark.notInGoals
  ).length;

  const doneDisplayCount = doneCount! - doneAndNotInGoalsCount!;

  const shouldShowCount =
    goalCount! + doneCount! - doneAndNotInGoalsCount! !== 0;

  return (
    <motion.div styleName="wrapper">
      {Object.keys(groupedSparks).map((skillId) => (
        <Fragment key={skillId}>
          <div
            onClick={(e) => {
              e?.stopPropagation();
              e?.preventDefault();
              setIsOpen((prev) => !prev);
            }}
            styleName="spark-skill"
            key={skillId}
          >
            <p styleName={`${type === 'reflection' ? 'reflection-skill' : ''}`}>
              {groupedSparks[skillId].name}
            </p>
            <div styleName="end">
              {type === 'reflection' ? (
                <>
                  {shouldShowCount && (
                    <p>
                      {doneDisplayCount} / {goalCount}
                    </p>
                  )}
                </>
              ) : goalCount === 0 ? null : (
                <p>{goalCount}</p>
              )}
              <motion.div
                initial={{ rotate: 0 }}
                animate={{ rotate: isOpen ? 180 : 0 }}
                exit={{ rotate: 0 }}
                transition={{ ease: 'easeInOut', duration: 0.5 }}
              >
                <FontAwesomeIcon icon={faChevronDown} styleName="icon" />
              </motion.div>
            </div>
          </div>
          <AnimatePresence>
            {isOpen &&
              (type !== 'reflection' ? (
                <>
                  {groupedSparks[skillId].sparks.map((spark, i) => (
                    <motion.div key={i} styleName="sparks " {...framerFade}>
                      <Spark
                        end
                        spark={spark}
                        key={spark?.id}
                        handleDelete={handleDelete}
                      />
                    </motion.div>
                  ))}
                </>
              ) : (
                <>
                  {groupedSparks[skillId].sparks.map((spark, i) => (
                    <motion.div key={i} styleName="sparks " {...framerFade}>
                      <SparkItem
                        setSparkLinkModalIsOpen={setSparkLinkModalIsOpen}
                        getSparkName={getSparkName}
                        item={spark}
                      />
                    </motion.div>
                  ))}
                </>
              ))}
          </AnimatePresence>
        </Fragment>
      ))}
    </motion.div>
  );
}
